import { baseAnimationDelay, baseDelay, visibilityEnterDelay, visibilityEnterDuration, wiperDuration } from "./variables"

export const svgTestVariants = {
    shallow: {
        d: "M530 130V0L265 0L0 0C0.00290468 0 0 130 0 130C0 130 121.271 120.611 265 120.611C408.729 120.611 530 130 530 130Z",
        transition: {
            duration: 1,
            ease: [0.16, 1, 0.3, 1]
        }
    },
    deep:{
        d: "M530 130V0L265 0L0 0C0.00290468 0 0 130 0 130C0 130 121.271 105.5 265 105.5C408.729 105.5 530 130 530 130Z",
        transition: {
            duration: 1,
            ease: [0.16, 1, 0.3, 1]
        }
    }
}

export const sideCurveVariantd={
    shallow: {
        d: "M7.35054e-06 530L130 530L130 265L130 0C130 0.00290468 3.05176e-05 -5.68248e-06 3.05176e-05 -5.68248e-06C3.05176e-05 -5.68248e-06 9.38902 121.271 9.3889 265C9.38878 408.729 7.35054e-06 530 7.35054e-06 530Z",
        transition: {
            duration: 1.5,
            ease: [0.16, 1, 0.3, 1]
        }
    }, deep: {
        d: "M7.35054e-06 530L130 530L130 265L130 0C130 0.00290468 3.05176e-05 -5.68248e-06 3.05176e-05 -5.68248e-06C3.05176e-05 -5.68248e-06 24.5001 121.271 24.5 265C24.4999 408.729 7.35054e-06 530 7.35054e-06 530Z",
        transition: {
            duration: 1.5,
            ease: [0.16, 1, 0.3, 1]
        }
    }
}


export const backgroundWrapperVariants = {
    initial: (i) => ({
        opacity: 0,
        transform: `scale3d(${i[0]}, ${i[1]}, 1)`
    }), animate: {
        transform: `scale3d(1, 1, 1)`,
        opacity: 1,
        transition: {
            delay: baseAnimationDelay+wiperDuration,
            duration: 1,
            ease: [0.16, 1, 0.3, 1],
            opacity: {
                delay: visibilityEnterDelay,
                duration: visibilityEnterDuration
            }
        }
    }, exit: {
        opacity: 0,
        transition: {
            duration: 0.5,
            delay: 0.25
        }
    }
}

export const scalerVariants = {
    initial: (i) => ({
        transform: `scale3d(${i[0]}, ${i[1]}, 1)`
    }), animate: {
        transform: `scale3d(1, 1, 1)`,
        transition: {
            delay: baseAnimationDelay + wiperDuration,
            duration: 1,
            ease: [0.16, 1, 0.3, 1]
        }
    }, exit: {

    }
}

export const maskScalerVariants = {
    initial: (i) => ({
        transform: `scale(1.5)`
    }), animate: {
        transform: `scale(1)`,
        transition: {
            delay: (baseAnimationDelay*9)/10,
            duration: 1,
            ease: [0.16, 1, 0.3, 1]
        }
    }, exit: {
    }
}